import { BoardIcon, ReportIcon, SettingsIcon, TagIcon, UserIcon } from '../components/icons';

// Keep desktop and mobile destinations in the same order.
export const MAIN_NAV = [
  { to: '/board', label: '보드', title: '콘텐츠 보드', Icon: BoardIcon },
  { to: '/products', label: '소재', title: '콘텐츠 소재', Icon: TagIcon },
  { to: '/dashboard', label: '리포트', title: '리포트', Icon: ReportIcon },
  { to: '/account', label: '계정', title: '계정 관리', Icon: UserIcon },
  { to: '/settings', label: '설정', title: '설정', Icon: SettingsIcon },
] as const;
